import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Wallet14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M8.25 10V8H9.75V10H8.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 1.25C2.48122 1.25 1.25 2.48122 1.25 4V10C1.25 11.5188 2.48122 12.75 4 12.75H11.5C12.1904 12.75 12.75 12.1904 12.75 11.5V5.25H4C3.30964 5.25 2.75 4.69036 2.75 4C2.75 3.30964 3.30964 2.75 4 2.75H11V1.25H4ZM2.75 6.45015V10C2.75 10.6904 3.30964 11.25 4 11.25H11.25V6.75H4C3.54989 6.75 3.12503 6.64186 2.75 6.45015Z'
      fill='currentColor'
    />
    <path
      d='M12 4.75V3.25H4C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75H12Z'
      fill='currentColor'
    />
  </Svg>
);

Wallet14.displayName = 'Wallet14';
export default Wallet14;
